export enum OrderType {
  ASC = 'ASC',
  DESC = 'DESC',
}
